import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthState, User } from '../interfaces';
import { RootState } from '../store';


const user = localStorage.getItem('user');
const accessToken = localStorage.getItem('accessToken');

const initialState: {
  user: Omit<User, 'password'> | null;
  accessToken: string | null;
} = {
  user: user ? JSON.parse(user) : null,
  accessToken,
}

const AuthSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, { payload: { user, accessToken } }:
      PayloadAction<AuthState>) => {
      state.user = user;
      state.accessToken = accessToken;
    }
  },
});

export const { setCredentials } = AuthSlice.actions;
export const selectCurrentUser = (state: RootState):
  Omit<User, 'password'> | null => state.auth.user;

export default AuthSlice.reducer;